/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
import { IllustratedMessage, Text, Title } from '@ui5/webcomponents-react';
import { ThemingParameters } from '@ui5/webcomponents-react-base';
import 'react-toastify/dist/ReactToastify.css';
import { useTranslations } from '../hooks/useTranslations';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/hooks';
import { actions } from '@/store/Products';
import { modifyAppContextData, triggerInstantFeedback } from '@/store/feedbackSlice';
import { useGetSystemInfoQuery } from '@/store/apis';
import * as storageUtils from '@/utils/storageUtils';

const Final = () => {
    const { t } = useTranslations();
    const dispatch = useAppDispatch();
    const skuName = useAppSelector(state => state.productList?.currentProduct?.productName);
    const productList = useAppSelector(state => state.productList);
    const pxApiStatus = useAppSelector(state => state.feedbackReducer.pxApiInitialized);
    const productName = productList.currentProduct?.productName;
    const runId = productList.currentRunId;
    const userInfo = storageUtils.getItem('user');
    const { data: qualtricsAreaId } = useGetSystemInfoQuery('qualtrics.area.id', { skip: !userInfo });
    const { data: qualtricsTriggerName } = useGetSystemInfoQuery('qualtrics.trigger.name.launch.personalization', { skip: !userInfo });

    useEffect(() => {
        dispatch(actions.setIsFinalPage(true));
        return () => {
            dispatch(actions.setIsFinalPage(false));
        };
    }, []);

    useEffect(() => {
        (async () => {
            const instantPushCondition = pxApiStatus && productName && runId && qualtricsAreaId && qualtricsTriggerName;

            if (instantPushCondition) {
                dispatch(modifyAppContextData({ appSupportInfo: productName, technicalAppComponentId: runId }));
                await dispatch(triggerInstantFeedback({ areaId: qualtricsAreaId.value, triggerName: qualtricsTriggerName.value }));
            }
        })();
    }, [pxApiStatus, productName, runId, qualtricsAreaId, qualtricsTriggerName]);

    return (
        <>
            <IllustratedMessage
                name="SuccessHighFive"
                className="final-illustrated-message"
                style={{ marginTop: ThemingParameters.sapContent_Margin_Large }}
            >
                <Title slot="title" style={{ fontSize: ThemingParameters.sapFontHeader2Size }}>
                    {t('CONGRATULATIONS')}
                </Title>
                <Text
                    slot="subtitle"
                    data-testid="final-subtitle"
                    style={{
                        marginTop: ThemingParameters.sapContent_Margin_Small,
                        fontSize: ThemingParameters.sapFontLargeSize,
                    }}
                >
                    {t('CONGRATULATIONS_MESSAGE', skuName)}
                </Text>
            </IllustratedMessage>
        </>
    );
};

export default Final;
